export default __webpack_public_path__ + "static/media/Manrope-Light.389976fb.woff";